import { makeStyles, Box } from "@material-ui/core";
import React, { useState } from "react";
import MobileButton from "../components/MobileButton";
import newsData from "../data/NewsData";
import Info from "./Info";

const useStyles = makeStyles((theme) => ({
  mobileContainer: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      width: "100%",
      height: "auto",
      //   backgroundColor: theme.palette.primary.main,
    },
  },
  box: {
    marginBottom: "10px",
  },
}));

export default function NewsMobile() {
  const [button, setButton] = useState(0);
  //   const [sub, setSub] = useState(false);
  const classes = useStyles();
  const onSelection = (id) => {
    if (id === button) {
      setButton(0);
    } else {
      setButton(id);
    }
  };
  return (
    <Box className={classes.mobileContainer}>
      {newsData.map((item) => (
        <Box key={item.id}>
          <MobileButton
            button={button}
            id={item.id}
            title={item.title}
            img={item.img}
            setButton={() => onSelection(item.id)}
          />
          {button === 1 && item.id === 1 ? <Info /> : ""}
        </Box>
      ))}
    </Box>
  );
}
